export default {
  "attGovInsight": () => import("/app/addons/hrm-addon-attendance-governance/views/AttendanceGovernanceOverview.vue"),
  "leaveCompliance": () => import("/app/addons/hrm-addon-leave-compliance-risk/views/LeaveComplianceRiskOverview.vue"),
  "orgCapacityHealth": () => import("/app/addons/hrm-addon-org-capacity-health/views/OrgCapacityHealthOverview.vue"),
  "staffProfileQuality": () => import("/app/addons/hrm-addon-staff-profile-quality/views/StaffProfileQualityOverview.vue")
}
